import $ from "jquery";
import "slick-carousel";

$(function () {
	$(".RelatedProducts-carousel").slick({
		arrows: true,
		infinite: true,
		slidesToShow: 4,
		centerPadding: 0,
		lazyLoad: "ondemand",
		prevArrow:
			'<button type="button" class="slick-prev"><i class="fas fa-caret-left"></i></button>',
		nextArrow:
			'<button type="button" class="slick-next"><i class="fas fa-caret-right"></i></button>',
		responsive: [
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 480,
				settings: {
					arrows: true,
					slidesToShow: 1,
				},
			},
		],
	});
});
